import { render, staticRenderFns } from "./AddContatoEndereco.vue?vue&type=template&id=2710b784&scoped=true"
import script from "./AddContatoEndereco.vue?vue&type=script&lang=js"
export * from "./AddContatoEndereco.vue?vue&type=script&lang=js"
import style0 from "./AddContatoEndereco.vue?vue&type=style&index=0&id=2710b784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710b784",
  null
  
)

export default component.exports